module.exports = __webpack_public_path__ + "img/collection-lg-01.3782b138.jpg";